import styled from 'styled-components';
import { media } from '~constants/media';

export const StyledRadio = styled.div<{
  isChecked: boolean;
  color: string;
  size: number;
}>`
  display: inline-block;
  box-sizing: content-box;
  position: relative;
  margin-right: 5px;
  background-color: transparent;
  border-radius: 50%;
  vertical-align: middle;

  ${media.md`
    margin-right: 13px;
  `}

  ${({ isChecked, color, size }) =>
    `
    width: ${size}px;
    height: ${size}px;
    border: 3px solid ${color};

    ${isChecked &&
      `
      &:after {
        content: '';
        position: absolute;
        width: 55%;
        height: 55%;
        background-color: ${color};
        border-radius: 50%;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    `}
  `}
`;
